import EditVSContainer from "./EditVSContainer";

export default EditVSContainer;
